import { 
  Component,
  OnInit, 
  Input,
  OnChanges,
  SimpleChange, 
  SimpleChanges, 
  EventEmitter,
  Output
} from '@angular/core';
import { ShapePosition } from './canvas/shapePosition';
import { ListItem } from "../model/listitem";
import { HttpApiService } from "app/services/http.api";
import { ConfigurateurGroupe, 
  ConfigurateurData, 
  ConfigurateurRubrique, 
  AConfigurateurDataPE, 
  ConfigurateurFacade, 
  ConfigurateurDesign, 
  ConfigurateurMateriau, 
  ConfigurateurModele, 
  IConfigurateurItemType,
  Constantes,
  ConfigurateurPoignee,
  ConfigurateurAccessoire,
  ConfigurateurVitrage,
  ConfigurateurCouleur,
  RenderModele,
  RenderCanvas,
  RenderDefault} from "app/model/configurateur";
import { ModeleService } from "app/services/modele.service";

@Component({
  selector: 'app-creator',
  templateUrl: './creator.component.html',
  styleUrls: ['./creator.component.css']
})
export class CreatorComponent implements OnInit {

  @Input() Configuration: ConfigurateurGroupe;
  @Output() CancelConfiguration = new EventEmitter<boolean>();
  
  public position : ShapePosition = { width: 200, height: 200, top:100, left:100};

  public renderCanvas:RenderCanvas;

  Data:ConfigurateurData;
  showDiaporama:boolean=false;
  rubriqueSelected:ConfigurateurRubrique;

  constructor(private appService: HttpApiService, private modeleService: ModeleService) { }

  ngOnInit() {
    
     // this.loadConfiguration();
   }

  onclick() {
    console.log('click button : move shape');
    var newposition = this.position;
    newposition.left += 50;
    this.position = { width: newposition.width, height: newposition.height, top:newposition.top, left:newposition.left};
  }

  loadConfiguration() {
    console.log('loadConfiguration');
    if (this.Configuration != null) {
        console.log('loadConfiguration avec groupe :' + this.Configuration.name);
        this.appService.getConfigurationData(this.Configuration.code).subscribe(data => { this.Data = data; this.loadDefault() });
    }
  }

  loadDefault() {
    if (this.Data != null && this.Data.defaultCodeFacade.length > 0) {
      var defaultFacade = this.Data.facades.filter(f => f.code == this.Data.defaultCodeFacade)[0];
      if (defaultFacade != null) {
        
        if (this.renderCanvas == null) {
            this.renderCanvas = this.modeleService.buildDefaultRender(this.Data, defaultFacade);
        }
      
        this.computeRubrique();
      }
    }
  }

  ngOnChanges(changes: {[propKey:string] : SimpleChange}){ // {[propKey:string] : SimpleChange} or SimpleChanges

      console.log('event received : onSelectGroup');
      this.loadConfiguration();
    }

    getRubriqueSelected() {
      return this.rubriqueSelected;
    }

    selectRubrique(rubrique:ConfigurateurRubrique) {
      console.log('selectRubrique : ' + (rubrique != null ? rubrique.code : 'not init'));
      
      if(this.rubriqueSelected != null) {
        this.showDiaporama = false;
      }
      
      setTimeout(() => {
        this.showDiaporama = true;
        this.rubriqueSelected = rubrique;
      }, 0);
      
      
    }

    onSelectItem(configurateurItem:RenderCanvas) {
      // build render modele
      this.renderCanvas = configurateurItem;
     
      this.computeRubrique();
    }

    computeRubrique() {
      
      // this.renderCanvas
      let countModeles:number = this.countModeles();
      let countCouleursByModele:number = this.countCouleursByModele();
      let countPoigneesByModele:number = this.countPoigneesByModele();
      let countAccessoiresByModele:number = this.countAccessoiresByModele();
      let countVitragesByModele:number = this.countVitragesByModele();


      let rubriqueAccessoires = this.Data.rubriques.find(r => r.code == Constantes.RUBRIQUE_ACCESSOIRES);
      if (rubriqueAccessoires != null) {
          rubriqueAccessoires.disable = (countAccessoiresByModele == 0);
      }

      let rubriqueVitrages = this.Data.rubriques.find(r => r.code == Constantes.RUBRIQUE_VITRAGES);
      if (rubriqueVitrages != null) {
          rubriqueVitrages.disable = (countVitragesByModele == 0);
      }

      let rubriquePoignees = this.Data.rubriques.find(r => r.code == Constantes.RUBRIQUE_POIGNEES);
      if (rubriquePoignees != null) {
          rubriquePoignees.disable = (countPoigneesByModele == 0);
      }

      let rubriqueCouleurs = this.Data.rubriques.find(r => r.code == Constantes.RUBRIQUE_COULEURS);
      if (rubriqueCouleurs != null) {
          rubriqueCouleurs.disable = (countCouleursByModele == 0);
      }

      let rubriqueModeles = this.Data.rubriques.find(r => r.code == Constantes.RUBRIQUE_MODELES);
      if (rubriqueModeles != null) {
          rubriqueModeles.disable = (countModeles == 0);
      }

      let rubriqueDocument = this.Data.rubriques.find(r => r.code == Constantes.RUBRIQUE_DOCUMENT);
      if (rubriqueDocument != null) {
          rubriqueDocument.disable = false;
      }

    }

    onDiaporamaClose(close:boolean) {
        if (close) {
          this.showDiaporama = false;
        }
    }

    onUpdateData(data:ConfigurateurData) {
      this.Data.clientId = data.clientId;
      // data.facades.forEach(facade => {
      //   if (this.Data.facades.findIndex(f => f.code == facade.code) == -1) {
      //     this.Data.facades.push(facade);
      //   }
      // });
      
    }


  countModeles():number {

      return (this.Data != null && this.Data.modeles != null && 
              this.renderCanvas != null && this.renderCanvas.modele ? 
        this.Data.modeles.filter(m => m.design.code == this.renderCanvas.modele.codeDesign && m.materiau.code == this.renderCanvas.modele.codeMateriau).length  : 0);
  }

  countCouleursByModele():number {
      
      return (this.Data != null && this.Data.couleurs != null && 
              this.renderCanvas != null && this.renderCanvas.modele ? 
        this.Data.couleurs.filter(c => c.codeModele == this.renderCanvas.modele.codeModele).length  : 0);
  }
  countPoigneesByModele():number {
      return (this.Data != null && this.Data.poignees != null && 
              this.renderCanvas != null && this.renderCanvas.modele ? 
        this.Data.poignees.filter(p => p.codeModele == this.renderCanvas.modele.codeModele).length  : 0);
  }
  countAccessoiresByModele():number {
      return (this.Data != null && this.Data.accessoires != null && 
              this.renderCanvas != null && this.renderCanvas.modele ? 
        this.Data.accessoires.filter(a => a.codeModele == this.renderCanvas.modele.codeModele).length  : 0);
  }
  countVitragesByModele():number {
    return (this.Data != null && this.Data.vitrages != null && 
              this.renderCanvas != null && this.renderCanvas.modele ? 
        this.Data.vitrages.filter(v => v.codeModele == this.renderCanvas.modele.codeModele).length  : 0);
  }


    onCancelConfiguration() {

      this.renderCanvas = null;
      
      this.CancelConfiguration.emit(true);
    }

    getVersion() {
      return (this.Data != null ? this.Data.version : 'not init yet !');
    }

    getRubriques() {
      return (this.Data != null && this.Data.rubriques != null ? this.Data.rubriques : null);
    }

     getData() {
      return (this.Data != null ? this.Data : null);
    }

    getImg() {
      return (this.Configuration != null && this.Configuration.img != null ? this.Configuration.img : '');
    }
}



// WEBPACK FOOTER //
// ./src/app/creator/creator.component.ts